(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  // Safari (particularly iOS) can restore a page from its back-forward
  // cache instead of re-running this script from a fresh load — e.g.
  // navigating back onto /cart, or a tab left open across a theme update.
  // The restored page keeps whatever DOM/JS closures existed at the moment
  // it was cached, while cart requests still hit the live server, so an
  // AJAX cart action can succeed (server state genuinely changes, badge
  // counts fetched elsewhere update) while the page's own view of the cart
  // never repaints — indistinguishable from a real bug until you reload.
  // Forcing a real reload on bfcache restoration keeps this page's script
  // always the one that actually shipped.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) window.location.reload();
  });

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.hidden = !mobileNav.hidden;
      menuToggle.setAttribute('aria-expanded', String(!mobileNav.hidden));
    });
  }

  /* ---------- Cart drawer + AJAX cart (add / qty / remove) ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');

  // The /cart page's own section id is NOT simply "main" — Shopify wraps
  // JSON-template sections as shopify-section-template--<id>__main, unlike
  // statically {% section %}-included ones (header, footer, cart-drawer)
  // which keep their plain name. Read the real id from the page itself
  // (sections/main-cart.liquid) rather than hardcoding a value that only
  // happens to be right for one theme/template instance.
  var cartPageSectionEl = document.querySelector('[data-cart-page-section-id]');
  var cartPageSectionId = cartPageSectionEl ? cartPageSectionEl.getAttribute('data-cart-page-section-id') : null;
  var cartSectionsParam = cartPageSectionId ? 'cart-drawer,' + cartPageSectionId : 'cart-drawer';

  function updateCartBadges(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      // The mobile icon's badge is a bare number, hide it at zero rather
      // than showing an empty-looking "0" bubble with nothing counted in
      // it. The desktop "Bag (0)" text stays as-is either way.
      if (el.classList.contains('site-header__cart-badge')) {
        el.hidden = cart.item_count === 0;
      }
    });
  }

  // Freezes the page behind an open drawer/modal. overflow: hidden on the
  // body alone doesn't stop iOS Safari scrolling the page underneath, so the
  // body is pinned with position: fixed at its current offset and put back
  // where it was on unlock. Counted so nested locks can't unlock early.
  var scrollLockCount = 0;
  var scrollLockY = 0;
  function lockPageScroll() {
    if (scrollLockCount++ > 0) return;
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    var bodyStyle = document.body.style;
    bodyStyle.position = 'fixed';
    bodyStyle.top = -scrollLockY + 'px';
    bodyStyle.left = '0';
    bodyStyle.right = '0';
    bodyStyle.width = '100%';
    bodyStyle.overflow = 'hidden';
    document.documentElement.classList.add('is-scroll-locked');
  }
  function unlockPageScroll() {
    if (scrollLockCount === 0 || --scrollLockCount > 0) return;
    var bodyStyle = document.body.style;
    bodyStyle.position = '';
    bodyStyle.top = '';
    bodyStyle.left = '';
    bodyStyle.right = '';
    bodyStyle.width = '';
    bodyStyle.overflow = '';
    document.documentElement.classList.remove('is-scroll-locked');
    window.scrollTo(0, scrollLockY);
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    var wasOpen = cartDrawer.classList.contains('is-open');
    cartDrawer.hidden = false;
    // Force layout before adding the class so the slide-in transition runs
    // rather than starting from the already-open state.
    requestAnimationFrame(function () {
      cartDrawer.classList.add('is-open');
    });
    if (!wasOpen) lockPageScroll();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    if (!cartDrawer.classList.contains('is-open')) return;
    cartDrawer.classList.remove('is-open');
    unlockPageScroll();
    setTimeout(function () {
      cartDrawer.hidden = true;
    }, 300); // matches the CSS slide-out transition duration
  }

  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    });
  }

  // Swaps freshly rendered section HTML (from Shopify's Section Rendering
  // API) into the page wherever that section's wrapper is actually present.
  // Requesting the /cart page's section while browsing a product page (it
  // won't be in cartSectionsParam there, but just in case) is harmless even
  // if it were — it still renders, we just have nothing to replace it with.
  //
  // "cart-drawer" is special-cased to an innerHTML swap of just its body:
  // the drawer root holds open/close state (the "is-open" class, the
  // `cartDrawer` reference above, its close-button listeners) that a full
  // replaceWith() would silently destroy the first time any cart mutation
  // ran, since the section's rendered root IS that same .cart-drawer
  // element.
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer'] && cartDrawer) {
      var freshDrawer = document.createElement('div');
      freshDrawer.innerHTML = sections['cart-drawer'];
      var freshBody = freshDrawer.querySelector('[data-cart-drawer-body]');
      var currentBody = cartDrawer.querySelector('[data-cart-drawer-body]');
      if (freshBody && currentBody) {
        currentBody.innerHTML = freshBody.innerHTML;
      } else {
        console.warn('[cart] Drawer section patch skipped — [data-cart-drawer-body] not found in the fresh render or the current DOM.');
      }
    }
    Object.keys(sections).forEach(function (id) {
      if (id === 'cart-drawer') return; // handled above
      var existing = document.getElementById('shopify-section-' + id);
      if (!existing) {
        // Should not normally happen: cartSectionsParam is built from ids
        // actually present on this page. If it does, something removed the
        // element after that id was captured — surface it instead of
        // leaving the page silently out of sync with the server.
        console.warn('[cart] Section patch skipped — no element with id "shopify-section-' + id + '" found in the DOM.');
        return;
      }
      var wrapper = document.createElement('div');
      wrapper.innerHTML = sections[id];
      var fresh = wrapper.firstElementChild;
      if (fresh) existing.replaceWith(fresh);
    });
  }

  // Shared by the drawer and the /cart page — both render the exact same
  // [data-cart-line-item] markup (snippets/cart-line-item.liquid), so one
  // delegated handler covers quantity changes and removal in either place.
  //
  // Built on /cart/update.js (accepts a {key: quantity, ...} map) rather
  // than /cart/change.js (one line at a time), because a row can represent
  // MORE THAN ONE underlying cart.items line: Shopify splits a variant into
  // a discounted line + a plain-price line when a discount only covers part
  // of its quantity (e.g. a bundle discount capped at one unit), instead of
  // merging them into one line at a blended price. Removing such a row has
  // to zero out every line for that variant in one request, not just one.
  //
  // Confirmed live (see the discount-bug investigation) that Shopify's
  // discount engine reallocates the discounted/plain split across a
  // variant's lines on ANY quantity change for that variant, regardless of
  // which specific line's key the request names — the key only selects
  // which line object to adjust, not which one ends up holding the
  // discount afterward. So it doesn't matter which line +/- targets; we
  // always use the row's first line (data-key/data-first-qty).
  function updateCartLines(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: cartSectionsParam })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartBadges(cart);
        applySections(cart.sections);
        return cart;
      })
      .catch(function (err) {
        // The server-side change can have genuinely succeeded even if this
        // request/response failed on the client (network blip, an
        // extension patching fetch, a slow connection) — without this, the
        // page is left showing stale quantities/totals with nothing in the
        // console tying it back to a cart action. Reload to reconcile with
        // whatever the server actually has, rather than leave it stale.
        console.error('[cart] Failed to update cart — reloading to recover the real state.', err);
        window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var lineItem = e.target.closest('[data-cart-line-item]');
    if (!lineItem) return;

    var firstKey = lineItem.getAttribute('data-key');
    var firstQty = parseInt(lineItem.getAttribute('data-first-qty'), 10) || 0;

    if (e.target.closest('[data-qty-increase]')) {
      var increaseUpdates = {};
      increaseUpdates[firstKey] = firstQty + 1;
      updateCartLines(increaseUpdates);
    } else if (e.target.closest('[data-qty-decrease]')) {
      var decreaseUpdates = {};
      decreaseUpdates[firstKey] = Math.max(0, firstQty - 1);
      updateCartLines(decreaseUpdates);
    } else if (e.target.closest('[data-cart-remove]')) {
      var allKeys = (lineItem.getAttribute('data-all-keys') || '').split(',').filter(Boolean);
      var removeUpdates = {};
      allKeys.forEach(function (k) { removeUpdates[k] = 0; });
      updateCartLines(removeUpdates);
    }
  });

  // Cart "Frequently bought together" box (snippets/cart-pairs-upsell.liquid).
  // Delegated because the drawer body is re-rendered via innerHTML, where
  // inline scripts never run. The cart line's own item is already in the
  // bag, so only the partner is added; the re-rendered sections then drop
  // the box (partner now in cart) and show the discounted total.
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cart-upsell-add]');
    if (!addBtn) return;
    var box = addBtn.closest('[data-cart-upsell]');
    var errorEl = box.querySelector('[data-cart-upsell-error]');
    var toggle = box.querySelector('[data-pairs-toggle]');
    if (toggle) toggle.checked = true;
    addBtn.disabled = true;
    errorEl.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(box.getAttribute('data-variant-id')), quantity: 1 }],
        sections: cartSectionsParam
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to your bag.');
          });
        }
        return res.json();
      })
      .then(function (addResult) {
        applySections(addResult.sections);
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(updateCartBadges);
      })
      .catch(function (err) {
        errorEl.textContent = err.message || 'Something went wrong adding this to your bag.';
        errorEl.hidden = false;
        addBtn.disabled = false;
      });
  });

  // Exposed so other independent add-to-cart flows on the page (e.g. the
  // "pairs with" bundle add-to-cart in snippets/pairs-with-bundle.liquid)
  // can update the badge and open the drawer without duplicating this logic.
  window.themeCart = {
    updateBadges: updateCartBadges,
    applySections: applySections,
    openDrawer: openCartDrawer
  };

  /* ---------- Trust pillars scroll dots ---------- */
  var trustScroll = document.querySelector('[data-trust-scroll]');
  var trustDots = document.querySelectorAll('[data-trust-dot]');
  if (trustScroll && trustDots.length) {
    var trustItems = trustScroll.querySelectorAll('.trust-pillars__item');
    var updateTrustDots = function () {
      var scrollLeft = trustScroll.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;
      trustItems.forEach(function (item, i) {
        var distance = Math.abs(item.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      trustDots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === closestIndex);
      });
    };
    var trustTicking = false;
    trustScroll.addEventListener('scroll', function () {
      if (!trustTicking) {
        window.requestAnimationFrame(function () {
          updateTrustDots();
          trustTicking = false;
        });
        trustTicking = true;
      }
    });
  }

  /* ---------- Size guide modal ---------- */
  var sizeGuideModal = document.querySelector('[data-size-guide-modal]');
  if (sizeGuideModal) {
    var openSizeGuide = function () {
      if (!sizeGuideModal.hidden) return;
      sizeGuideModal.hidden = false;
      lockPageScroll();
    };
    var closeSizeGuide = function () {
      if (sizeGuideModal.hidden) return;
      sizeGuideModal.hidden = true;
      unlockPageScroll();
    };
    document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', openSizeGuide);
    });
    sizeGuideModal.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', closeSizeGuide);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sizeGuideModal.hidden) closeSizeGuide();
    });
  }

  /* ---------- Accordions (FAQ + product) ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.faq__item');
      var panel = item.querySelector('[data-accordion-panel]');
      var sign = item.querySelector('[data-accordion-sign]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      if (sign) sign.textContent = isOpen ? '+' : '–';
    });
  });

  /* ---------- Product media gallery (carousel) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var root = gallery.closest('.product-media') || gallery.parentNode;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var counter = gallery.querySelector('[data-gallery-counter]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    var thumbs = root.querySelectorAll('[data-media-thumb]');
    if (!track || !slides.length) return;

    var targetIndex = 0;

    // Slide widths are fractional (e.g. 528.18px) but track.scrollLeft /
    // track.clientWidth are integer APIs, so index math built on them drifts
    // by a growing sub-pixel amount per slide and leaves a sliver of the
    // next slide visible. Compare actual rendered edges (fractional) instead.
    function currentIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }

    function updateUI(index) {
      if (index === undefined) index = currentIndex();
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
    }

    function isAligned(slide) {
      return Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left) < 1;
    }

    // Horizontal-only scroll of the track itself, not scrollIntoView — that
    // carries a vertical "block" component too, and since nothing here
    // establishes the track as the nearest scrollable ancestor on the
    // vertical axis, the browser falls back to scrolling the whole page to
    // bring the slide into view (e.g. jumping to top when a variant change
    // is triggered from an option control further down the page).
    function scrollTrackToSlide(slide, behavior) {
      var delta = slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: delta, behavior: behavior });
    }

    // Holds the pending alignment-fallback timer (see goTo below) so a
    // second goTo() call before it fires can cancel it.
    var alignTimeout;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      targetIndex = index;
      var slide = slides[index];
      scrollTrackToSlide(slide, 'smooth');
      // Reflect the target immediately so the counter/dots/thumbs feel instant
      // rather than waiting on the scroll animation to finish.
      updateUI(index);
      // Fallback in case the smooth-scroll animation doesn't commit
      // (e.g. reduced-motion settings or throttled backgrounded tabs). Must
      // be cancelled on every new call — otherwise a goTo() fired again
      // before this timer elapses (e.g. switching swatches twice quickly,
      // or a swatch click landing soon after the page's own initial variant
      // correction) leaves this stale timer pointing at the PREVIOUS slide.
      // It then fires later, finds the track no longer aligned with that old
      // slide (because we've since moved on), and force-snaps back to it —
      // a visible flash back to the previous image before the new target's
      // own fallback timer corrects it a moment after.
      clearTimeout(alignTimeout);
      alignTimeout = setTimeout(function () {
        if (!isAligned(slide)) scrollTrackToSlide(slide, 'auto');
      }, 400);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(targetIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(targetIndex + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        targetIndex = currentIndex();
        updateUI(targetIndex);
      }, 80);
    });

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () { goTo(targetIndex); }, 100);
    });

    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      var mediaSrc = variant && variant.featured_image && variant.featured_image.src;
      var mediaFilename = mediaSrc ? mediaSrc.split('/').pop().split('?')[0] : null;
      if (!mediaFilename) return;
      var index = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-filename') === mediaFilename) {
          index = i;
          break;
        }
      }
      if (index > -1) goTo(index);
    });
  });

  /* ---------- Variant picker ---------- */
  var form = document.getElementById('ProductForm');
  if (form) {
    var variantsJson = document.getElementById('ProductVariantsJson');
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var optionGroups = form.querySelectorAll('[data-option-index]');
    var variantIdInput = document.getElementById('ProductVariantId');
    var priceEl = document.getElementById('ProductPrice');
    var addBtn = document.getElementById('AddToCart');
    var addBtnText = form.querySelector('[data-add-to-cart-text]');
    var klarnaAmountEl = document.getElementById('KlarnaAmount');
    var stickyBar = document.querySelector('[data-sticky-bar]');
    var stickyPriceEl = document.getElementById('StickyBarPrice');
    var stickyBtn = stickyBar ? stickyBar.querySelector('.product-sticky-bar__button') : null;

    function currentSelection() {
      var selection = [];
      optionGroups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selection.push(checked ? checked.value : null);
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selection.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' });
    }

    function updateSwatchStyles() {
      form.querySelectorAll('.product-form__swatch').forEach(function (label) {
        var input = label.querySelector('input');
        label.classList.toggle('is-selected', !!(input && input.checked));
      });
    }

    var metalMaterialEl = form.querySelector('[data-metal-material]');
    function updateMetalMaterial() {
      if (!metalMaterialEl) return;
      var checked = form.querySelector('[data-metal-material-value] input:checked');
      if (!checked) return;
      var material = checked.closest('[data-metal-material-value]').getAttribute('data-metal-material-value');
      if (material) metalMaterialEl.textContent = material;
    }

    function onOptionChange() {
      updateSwatchStyles();
      updateMetalMaterial();
      var variant = findVariant(currentSelection());
      if (!variant) return;
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (klarnaAmountEl) klarnaAmountEl.textContent = money(Math.round(variant.price / 3));
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addBtnText) {
          addBtnText.textContent = variant.available
            ? 'Add to bag, ' + money(variant.price)
            : 'Sold out';
        }
      }
      if (stickyPriceEl) stickyPriceEl.textContent = money(variant.price);
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
    }

    form.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', onOptionChange);
    });
    updateSwatchStyles();

    var initialVariant = findVariant(currentSelection());
    if (initialVariant) {
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: initialVariant } }));
    }

    // Sticky add-to-bag bar (mobile): shows once the real add-to-bag
    // button (in .product-form__actions) has scrolled up past the top of
    // the screen, hides again once it's back on screen. Only "above the
    // viewport" counts: before the customer has reached the button (it
    // starts below the fold on mobile) the bar stays hidden, otherwise it
    // popped in at page load, out at the button, and in again past it.
    // The top edge is also stable while the mobile address bar resizes the
    // viewport, so the bar doesn't flicker as that toolbar shows/hides.
    if (stickyBar && 'IntersectionObserver' in window) {
      var addToCartRow = form.querySelector('.product-form__actions');
      if (addToCartRow) {
        var stickyObserver = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', scrolledPast);
        });
        stickyObserver.observe(addToCartRow);
      }
    }

    if ((window.themeSettings || {}).cartType === 'notification') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        formData.append('sections', 'cart-drawer');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) { return res.json(); })
          .then(function (addResult) {
            applySections(addResult.sections);
            return fetch('/cart.js');
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartBadges(cart);
            openCartDrawer();
            announce(cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in your bag');
          })
          .catch(function () {
            form.submit();
          });
      });
    }
  }

  function announce(message) {
    var region = document.getElementById('ScreenReaderAnnouncer');
    if (region) region.textContent = message;
  }

  /* ---------- Set view (?set= param on necklace PDPs) ----------
     Links from /collections/sets land here with e.g. ?set=axis rather than
     on a dedicated set page (see sections/sets-grid.liquid) — the existing
     "Frequently bought together" box (snippets/pairs-with-bundle.liquid)
     already has everything a set needs, so this just pre-selects its
     bundle toggle (which the box's own script uses to take over the main
     Add to Bag button's wording/price — see updateMainButtonPrice in that
     snippet) and swaps the H1 to read "Axis Set" instead of "Axis
     Necklace", derived generically from the product title (no per-set
     mapping to maintain here). The box itself is hidden by CSS
     (.pairs-bundle.is-set-view) rather than shown alongside the main
     button, so there's one unambiguous "Add Both to Bag" action, not two
     UI elements quoting the same total. Does nothing if the product has no
     FBT pairing configured (no [data-pairs-bundle] on the page). */
  var setParam = new URLSearchParams(window.location.search).get('set');
  if (setParam) {
    // Drives the !important CSS in theme.css that hides the review badge/
    // section — a plain .hidden = true on those elements isn't enough on
    // its own, since Judge.me's widget script re-applies its own display
    // styling once it finishes hydrating (async, after this script runs).
    document.body.classList.add('is-set-view');

    var h1 = document.querySelector('.product-info h1');
    if (h1) {
      // "Axis Necklace: Moissanite Pendant Necklace" -> "Axis Necklace" -> "Axis Set"
      var originalH1Text = h1.textContent;
      var setTitle = originalH1Text.split(':')[0].trim().replace(/Necklace$/, 'Set').trim();
      h1.textContent = setTitle;
      // <title> starts with page_title (the product title) followed by
      // " – Vocco" etc. (see layout/theme.liquid) — only swap that
      // leading portion, leaving the rest of the tag's formatting alone.
      if (document.title.indexOf(originalH1Text) === 0) {
        document.title = setTitle + document.title.slice(originalH1Text.length);
      }
      // Same derived name for the breadcrumb's trailing crumb — see
      // sections/main-product.liquid, [data-breadcrumb-title] wraps just
      // the product-title portion so the "Home / Collection /" prefix is
      // untouched.
      var breadcrumbTitle = document.querySelector('[data-breadcrumb-title]');
      if (breadcrumbTitle) breadcrumbTitle.textContent = setTitle;
      // And the mobile sticky bar's name (its price/button follow the
      // bundle state in snippets/pairs-with-bundle.liquid).
      var stickyTitle = document.querySelector('[data-sticky-bar] .product-sticky-bar__title');
      if (stickyTitle) stickyTitle.textContent = setTitle;
    }

    // Swap in the set-specific Description/Specification copy (product
    // metafields custom.set_description / custom.set_specification) in
    // place of the necklace's own — "The Axis Necklace is..." reads oddly
    // on a set page. Liquid can't see the ?set= param, so main-product.liquid
    // renders both and hides the -set one; only swap here, and only when
    // the merchant has actually filled the metafield in (data-desc-set /
    // data-specs-set only exist in the DOM when it's non-blank), otherwise
    // the normal content stays put rather than swapping to something empty.
    var descNormal = document.querySelector('[data-desc-normal]');
    var descSet = document.querySelector('[data-desc-set]');
    if (descNormal && descSet) {
      descNormal.hidden = true;
      descSet.hidden = false;
    }
    var specsNormal = document.querySelector('[data-specs-normal]');
    var specsSet = document.querySelector('[data-specs-set]');
    if (specsNormal && specsSet) {
      specsNormal.hidden = true;
      specsSet.hidden = false;
    }

    // The necklace's own Judge.me reviews — both the star rating/count
    // badge near the price and the full written-reviews section further
    // down the page — read oddly attached to a set page, so hide both
    // here rather than in Liquid (which can't see ?set=).
    var reviewBadge = document.querySelector('[data-review-badge]');
    if (reviewBadge) reviewBadge.hidden = true;
    var reviewSection = document.querySelector('[data-review-section]');
    if (reviewSection) reviewSection.hidden = true;

    var bundleBox = document.querySelector('[data-pairs-bundle]');
    if (bundleBox) {
      bundleBox.classList.add('is-set-view');

      var setToggle = bundleBox.querySelector('[data-pairs-toggle]');
      if (setToggle && !setToggle.disabled) {
        setToggle.checked = true;
        setToggle.dispatchEvent(new Event('change'));
      }
    }
  }
})();
